<template>
    <div>
        <v-menu
                ref="menu"
                v-model="pickerOpen"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                        v-model="formattedDate"
                        readonly
                        v-bind="attrs"
                        v-on="!readonly ? on : null"
                        :error-messages="errorMessages"
                        :label="label"
                        max-width="290px"
                        :clearable="clearable"
                />
            </template>
            <v-date-picker
                    :show-week="true"
                    type="date"
                    @change="dateChange"
                    first-day-of-week="1"
                    v-model="date"
                    :readonly="readonly"
            >
            </v-date-picker>
        </v-menu>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        props: {
            value: {
                type: String
            },
            label: {
                type: String,
                default: 'Date'
            },
            required: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false
            },
            errorMessages: {
                type: Array
            },
            readonly: {
                type: Boolean,
                default:false
            },
        },
        data() {
            return {
                pickerOpen: false,
                date: this.value,
            }
        },
        computed: {
            formattedDate: {
              get: function () {
                if(this.value == null) {
                    return '';
                }

                return moment(this.value).format("ddd, D MMMM YYYY");
              },
              set: function () {
                this.$emit('input', this.date)
              }
            }
        },
        methods: {
            dateChange() {
                this.pickerOpen = false
                this.$emit('input', this.date)
            }
        },
    }
</script>

<style scoped>

</style>